// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-display {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Near-black: wall phones are OLED and on 24/7; dark pixels rest. */
  background: #05080c;
  color: #e3eaf2;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  overflow: hidden;
  padding: calc(12px + env(safe-area-inset-top, 0px))
    calc(12px + env(safe-area-inset-right, 0px))
    calc(12px + env(safe-area-inset-bottom, 0px))
    calc(12px + env(safe-area-inset-left, 0px));
}

/* Living hex grid (components/HexGridBackground.tsx) behind the card.
   Dimmed: the faces keep the screen alive against burn-in, but OLED
   power and wear scale with brightness on a screen that never sleeps. */
.dd-hexgrid {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  opacity: 0.6;
}

.dd-identify {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(0.3rem, 2vh, 1rem);
  padding: 1rem;
  text-align: center;
  background: #f5c542;
  color: #111820;
}

.dd-identify p { margin: 0; overflow-wrap: anywhere; }
.dd-identify-label { font-size: clamp(1rem, 5vw, 2rem); font-weight: 900; letter-spacing: 0.15em; }
.dd-identify-serial { font-size: clamp(2.5rem, 15vw, 7rem); font-weight: 950; line-height: 1; }
.dd-identify-model { font-size: clamp(1.3rem, 7vw, 3rem); font-weight: 800; }
.dd-identify-meta, .dd-identify-location { font-size: clamp(1rem, 4vw, 1.7rem); font-weight: 650; }

.dd-panel {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  width: min(100%, 720px);
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  text-align: center;
  padding: clamp(0.9rem, 4vw, 1.6rem);
  border-radius: 1rem;
  /* Translucent dark card keeps text legible over the grid without a
     large static bright block. */
  background: rgba(5, 8, 12, 0.8);
  border: 1px solid rgba(183, 194, 206, 0.12);
  /* Pixel shift against burn-in: wander a few px around a loop over
     16 minutes in discrete ~1px steps (12 per leg, one every 20s), so
     static text never sits on the same pixels and no frame-rate
     animation runs between steps. */
  animation: dd-pixel-shift 960s steps(12, end) infinite;
}

@keyframes dd-pixel-shift {
  0%,
  100% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(8px, -6px);
  }
  50% {
    transform: translate(-3px, 8px);
  }
  75% {
    transform: translate(-8px, -4px);
  }
}

.dd-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
}

.dd-connection {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  font-size: clamp(0.85rem, 3.4vw, 1.1rem);
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #b7c2ce;
}

.dd-dot {
  width: 0.6em;
  height: 0.6em;
  border-radius: 50%;
  background: #b7c2ce;
  flex: none;
}

.dd-dot-live {
  background: #7be38b;
}

.dd-dot-reconnecting,
.dd-dot-connecting {
  background: #f2c14e;
}

.dd-dot-offline,
.dd-dot-expired {
  background: #ff9f9f;
}

.dd-owner {
  margin: 0;
  font-size: clamp(0.95rem, 4vw, 1.45rem);
  font-weight: 600;
  color: #dbe4ee;
  overflow-wrap: anywhere;
  line-height: 1.3;
}

.dd-owner-part {
  display: block;
}

.dd-owner-job {
  font-weight: 500;
  color: #b7c2ce;
}

.dd-primary {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  min-width: 0;
}

.dd-phase {
  margin: 0;
  font-size: clamp(1.5rem, 8vw, 3rem);
  font-weight: 800;
  line-height: 1.15;
  overflow-wrap: anywhere;
}

.dd-identity {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0.2rem 0.8rem;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  padding-top: 0.6rem;
  border-top: 1px solid rgba(183, 194, 206, 0.12);
  text-align: left;
  font-size: clamp(0.8rem, 3.2vw, 1rem);
  line-height: 1.35;
}

.dd-identity > div {
  display: contents;
}

.dd-identity dt {
  color: #8d9aa8;
  font-weight: 600;
}

.dd-identity dd {
  margin: 0;
  min-width: 0;
  color: #dbe4ee;
  overflow-wrap: anywhere;
}

.dd-identity-id dd {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.85em;
  color: #b7c2ce;
}

.dd-download {
  margin: 0;
  font-size: clamp(0.9rem, 3.6vw, 1.25rem);
  color: #c9d4df;
  overflow-wrap: anywhere;
}

.dd-bar {
  display: block;
  height: 0.55rem;
  border-radius: 0.3rem;
  background: #26313d;
  border: 1px solid #3a4756;
  margin-bottom: 0.35rem;
  overflow: hidden;
}

.dd-bar-fill {
  display: block;
  height: 100%;
  background: #7be38b;
}

.dd-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.4rem 0.8rem;
  font-size: clamp(0.8rem, 3.2vw, 1rem);
  color: #b7c2ce;
  min-width: 0;
}

.dd-context {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.4rem;
  min-width: 0;
}

.dd-chip {
  border: 1px solid #3a4756;
  border-radius: 0.4rem;
  padding: 0.1rem 0.5rem;
  overflow-wrap: anywhere;
  max-width: 100%;
}

.dd-stale {
  margin: 0;
  font-size: clamp(0.7rem, 2.8vw, 0.85rem);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #f2c14e;
}

.dd-status-expired .dd-phase,
.dd-status-inactive .dd-phase {
  color: #b7c2ce;
}

@media (prefers-reduced-motion: no-preference) {
  .dd-dot-live {
    animation: dd-pulse 1.6s ease-in-out infinite;
  }
  .dd-status-reconnecting .dd-dot {
    animation: dd-pulse 1s linear infinite;
  }
}

@keyframes dd-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@media (orientation: landscape) and (max-height: 480px) {
  .dd-panel {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
    grid-template-areas:
      "header primary"
      "owner primary"
      "identity primary"
      "meta stale";
    align-items: center;
    gap: 0.2rem 1.2rem;
    text-align: left;
    width: min(100%, 980px);
  }
  .dd-header {
    grid-area: header;
    align-items: flex-start;
  }
  .dd-owner {
    grid-area: owner;
    text-align: left;
  }
  .dd-primary {
    grid-area: primary;
    align-items: flex-start;
    text-align: left;
  }
  .dd-phase {
    font-size: clamp(1.3rem, 6vw, 2.2rem);
  }
  .dd-identity {
    grid-area: identity;
    margin: 0;
  }
  .dd-meta {
    grid-area: meta;
    justify-content: flex-start;
  }
  .dd-stale {
    grid-area: stale;
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./dashboard/src/pages/DeviceDisplay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oEAAoE;EACpE,mBAAmB;EACnB,cAAc;EACd;uCACqC;EACrC,gBAAgB;EAChB;;;+CAG6C;AAC/C;;AAEA;;wEAEwE;AACxE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB,SAAS,EAAE,uBAAuB,EAAE;AACrD,qBAAqB,iCAAiC,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAClG,sBAAsB,oCAAoC,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9F,qBAAqB,mCAAmC,EAAE,gBAAgB,EAAE;AAC5E,2CAA2C,mCAAmC,EAAE,gBAAgB,EAAE;;AAElG;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB;iCAC+B;EAC/B,+BAA+B;EAC/B,2CAA2C;EAC3C;;;oCAGkC;EAClC,sDAAsD;AACxD;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,qEAAqE;EACrE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,sDAAsD;IACtD;;;;kBAIc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".device-display {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Near-black: wall phones are OLED and on 24/7; dark pixels rest. */\n  background: #05080c;\n  color: #e3eaf2;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  overflow: hidden;\n  padding: calc(12px + env(safe-area-inset-top, 0px))\n    calc(12px + env(safe-area-inset-right, 0px))\n    calc(12px + env(safe-area-inset-bottom, 0px))\n    calc(12px + env(safe-area-inset-left, 0px));\n}\n\n/* Living hex grid (components/HexGridBackground.tsx) behind the card.\n   Dimmed: the faces keep the screen alive against burn-in, but OLED\n   power and wear scale with brightness on a screen that never sleeps. */\n.dd-hexgrid {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  opacity: 0.6;\n}\n\n.dd-identify {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(0.3rem, 2vh, 1rem);\n  padding: 1rem;\n  text-align: center;\n  background: #f5c542;\n  color: #111820;\n}\n\n.dd-identify p { margin: 0; overflow-wrap: anywhere; }\n.dd-identify-label { font-size: clamp(1rem, 5vw, 2rem); font-weight: 900; letter-spacing: 0.15em; }\n.dd-identify-serial { font-size: clamp(2.5rem, 15vw, 7rem); font-weight: 950; line-height: 1; }\n.dd-identify-model { font-size: clamp(1.3rem, 7vw, 3rem); font-weight: 800; }\n.dd-identify-meta, .dd-identify-location { font-size: clamp(1rem, 4vw, 1.7rem); font-weight: 650; }\n\n.dd-panel {\n  position: relative;\n  z-index: 1;\n  box-sizing: border-box;\n  width: min(100%, 720px);\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  text-align: center;\n  padding: clamp(0.9rem, 4vw, 1.6rem);\n  border-radius: 1rem;\n  /* Translucent dark card keeps text legible over the grid without a\n     large static bright block. */\n  background: rgba(5, 8, 12, 0.8);\n  border: 1px solid rgba(183, 194, 206, 0.12);\n  /* Pixel shift against burn-in: wander a few px around a loop over\n     16 minutes in discrete ~1px steps (12 per leg, one every 20s), so\n     static text never sits on the same pixels and no frame-rate\n     animation runs between steps. */\n  animation: dd-pixel-shift 960s steps(12, end) infinite;\n}\n\n@keyframes dd-pixel-shift {\n  0%,\n  100% {\n    transform: translate(0, 0);\n  }\n  25% {\n    transform: translate(8px, -6px);\n  }\n  50% {\n    transform: translate(-3px, 8px);\n  }\n  75% {\n    transform: translate(-8px, -4px);\n  }\n}\n\n.dd-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  min-width: 0;\n}\n\n.dd-connection {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5em;\n  font-size: clamp(0.85rem, 3.4vw, 1.1rem);\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: #b7c2ce;\n}\n\n.dd-dot {\n  width: 0.6em;\n  height: 0.6em;\n  border-radius: 50%;\n  background: #b7c2ce;\n  flex: none;\n}\n\n.dd-dot-live {\n  background: #7be38b;\n}\n\n.dd-dot-reconnecting,\n.dd-dot-connecting {\n  background: #f2c14e;\n}\n\n.dd-dot-offline,\n.dd-dot-expired {\n  background: #ff9f9f;\n}\n\n.dd-owner {\n  margin: 0;\n  font-size: clamp(0.95rem, 4vw, 1.45rem);\n  font-weight: 600;\n  color: #dbe4ee;\n  overflow-wrap: anywhere;\n  line-height: 1.3;\n}\n\n.dd-owner-part {\n  display: block;\n}\n\n.dd-owner-job {\n  font-weight: 500;\n  color: #b7c2ce;\n}\n\n.dd-primary {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  min-width: 0;\n}\n\n.dd-phase {\n  margin: 0;\n  font-size: clamp(1.5rem, 8vw, 3rem);\n  font-weight: 800;\n  line-height: 1.15;\n  overflow-wrap: anywhere;\n}\n\n.dd-identity {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 0.2rem 0.8rem;\n  width: fit-content;\n  max-width: 100%;\n  margin: 0 auto;\n  padding-top: 0.6rem;\n  border-top: 1px solid rgba(183, 194, 206, 0.12);\n  text-align: left;\n  font-size: clamp(0.8rem, 3.2vw, 1rem);\n  line-height: 1.35;\n}\n\n.dd-identity > div {\n  display: contents;\n}\n\n.dd-identity dt {\n  color: #8d9aa8;\n  font-weight: 600;\n}\n\n.dd-identity dd {\n  margin: 0;\n  min-width: 0;\n  color: #dbe4ee;\n  overflow-wrap: anywhere;\n}\n\n.dd-identity-id dd {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 0.85em;\n  color: #b7c2ce;\n}\n\n.dd-download {\n  margin: 0;\n  font-size: clamp(0.9rem, 3.6vw, 1.25rem);\n  color: #c9d4df;\n  overflow-wrap: anywhere;\n}\n\n.dd-bar {\n  display: block;\n  height: 0.55rem;\n  border-radius: 0.3rem;\n  background: #26313d;\n  border: 1px solid #3a4756;\n  margin-bottom: 0.35rem;\n  overflow: hidden;\n}\n\n.dd-bar-fill {\n  display: block;\n  height: 100%;\n  background: #7be38b;\n}\n\n.dd-meta {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.4rem 0.8rem;\n  font-size: clamp(0.8rem, 3.2vw, 1rem);\n  color: #b7c2ce;\n  min-width: 0;\n}\n\n.dd-context {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.dd-chip {\n  border: 1px solid #3a4756;\n  border-radius: 0.4rem;\n  padding: 0.1rem 0.5rem;\n  overflow-wrap: anywhere;\n  max-width: 100%;\n}\n\n.dd-stale {\n  margin: 0;\n  font-size: clamp(0.7rem, 2.8vw, 0.85rem);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #f2c14e;\n}\n\n.dd-status-expired .dd-phase,\n.dd-status-inactive .dd-phase {\n  color: #b7c2ce;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .dd-dot-live {\n    animation: dd-pulse 1.6s ease-in-out infinite;\n  }\n  .dd-status-reconnecting .dd-dot {\n    animation: dd-pulse 1s linear infinite;\n  }\n}\n\n@keyframes dd-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.35;\n  }\n}\n\n@media (orientation: landscape) and (max-height: 480px) {\n  .dd-panel {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);\n    grid-template-areas:\n      \"header primary\"\n      \"owner primary\"\n      \"identity primary\"\n      \"meta stale\";\n    align-items: center;\n    gap: 0.2rem 1.2rem;\n    text-align: left;\n    width: min(100%, 980px);\n  }\n  .dd-header {\n    grid-area: header;\n    align-items: flex-start;\n  }\n  .dd-owner {\n    grid-area: owner;\n    text-align: left;\n  }\n  .dd-primary {\n    grid-area: primary;\n    align-items: flex-start;\n    text-align: left;\n  }\n  .dd-phase {\n    font-size: clamp(1.3rem, 6vw, 2.2rem);\n  }\n  .dd-identity {\n    grid-area: identity;\n    margin: 0;\n  }\n  .dd-meta {\n    grid-area: meta;\n    justify-content: flex-start;\n  }\n  .dd-stale {\n    grid-area: stale;\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
